__turbopack_context__.v({
  "chip": "CategoryFilter-module-scss-module__WaMOAq__chip",
  "dragging": "CategoryFilter-module-scss-module__WaMOAq__dragging",
  "fade-left": "CategoryFilter-module-scss-module__WaMOAq__fade-left",
  "fade-right": "CategoryFilter-module-scss-module__WaMOAq__fade-right",
  "nudge": "CategoryFilter-module-scss-module__WaMOAq__nudge",
  "scrollbar": "CategoryFilter-module-scss-module__WaMOAq__scrollbar",
  "scrollbar-visible": "CategoryFilter-module-scss-module__WaMOAq__scrollbar-visible",
  "scroller": "CategoryFilter-module-scss-module__WaMOAq__scroller",
  "scroller-overflow": "CategoryFilter-module-scss-module__WaMOAq__scroller-overflow",
  "thumb": "CategoryFilter-module-scss-module__WaMOAq__thumb",
  "thumb-active": "CategoryFilter-module-scss-module__WaMOAq__thumb-active",
  "viewport": "CategoryFilter-module-scss-module__WaMOAq__viewport",
  "wrapper": "CategoryFilter-module-scss-module__WaMOAq__wrapper",
});
